// ABOUTME: Large icon in gradient container for maintenance page
// ABOUTME: Matches EmptyStateCard pattern with scale-up animation

import { Wrench } from "lucide-react";

export function MaintenanceIcon() {
  return (
    <div className="flex h-24 w-24 items-center justify-center rounded-3xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20 shadow-lg shadow-primary/10 transition-transform duration-300 hover:scale-105">
      <Wrench className="size-12 text-primary" strokeWidth={1.5} />
    </div>
  );
}
